import cn from 'clsx'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Caption from 'components/Luxkit/Typography/Caption'
import getLoyaltyTierDisplayName from 'loyalty/selectors/getLoyaltyTierDisplayName'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Badge = styled(Caption)`
  border-radius: ${props => props.theme.borderRadius.S};

  &.size-small {
    padding: ${rem(4)} ${rem(8)};
  }

  &.size-large {
    height: ${rem(32)};
    width: ${rem(96)};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalBackground};
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalBackground};
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalBackground};
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }
`

interface Props {
  tier: App.LoyaltyTier;
  /**
   * @default small
   */
  size?: 'small' | 'large';
}

function LoyaltyTierBadge({
  tier,
  size = 'small',
}: Props) {
  return <Badge
    className={cn(`tier-${tier}`, `size-${size}`)}
    variant={size === 'large' ? 'large' : 'medium'}
    format={size === 'small' ? 'uppercase' : undefined}
    as={size === 'large' ? BodyText : undefined}
    align="center"
  >
    {getLoyaltyTierDisplayName(tier)}
  </Badge>
}

export default LoyaltyTierBadge
